import { tzAxios } from 'api/axios';
import { HomeResponse } from 'api/responseTypes';

export const getUpcomingMatches = async () =>
  (await tzAxios.get<HomeResponse>('/ticket-zone/home?type=SPORT')).data;
